import { Text } from "@/components/elements/Text";

import { SectionType } from "../types";
import { QACombo } from "./QACombo";
import styles from "./styles.module.css";

export const Section = ({ header, list }: SectionType) => (
  <>
    <Text as="h2" size="l" responsive className={styles.header}>
      {header}
    </Text>
    {list.map((item) => (
      <QACombo {...item} key={item.question} />
    ))}
  </>
);
